import { Route, Routes } from 'react-router-dom'

import List from './screens/List/List'

const CanvaTemplatesRoutes = () => (
  <Routes>
    <Route path="/" element={<List />} />
  </Routes>
)

export default CanvaTemplatesRoutes
